import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type TypeOptions = "prime" | "non_prime";

export const homeScreenFilterSlice = createSlice({
  name: "homeScreenFilter",
  initialState: {
    period: 0,
    year: new Date().getFullYear(),
    type: ["prime", "non_prime"],
    member: "All",
    // Multi-select. Empty array = "all companies the user has access to" —
    // matches the backend's existing fallback (omit `companies` -> use
    // user.companies / all companies for System Admin), so an empty
    // selection here should simply not be sent as a filter.
    companies: [] as string[],
  },
  reducers: {
    setPeriod: (state, action: PayloadAction<number>) => {
      state.period = action.payload;
    },
    setYear: (state, action: PayloadAction<number>) => {
      state.year = action.payload;
    },
    setMember: (state, action: PayloadAction<string>) => {
      state.member = action.payload;
    },
    setType: (state, action: PayloadAction<TypeOptions[]>) => {
      state.type = action.payload;
    },
    setCompanies: (state, action: PayloadAction<string[]>) => {
      state.companies = action.payload;
    },
    resetFilters: (state) => {
      state.period = 0;
      state.year = new Date().getFullYear();
      state.member = "All";
      state.companies = [];
    },
  },
});

export const {
  setPeriod,
  setYear,
  setMember,
  resetFilters,
  setType,
  setCompanies,
} = homeScreenFilterSlice.actions;

export default homeScreenFilterSlice.reducer;
